<template>
  <!-- Planned sign-out countdown: a System Admin is taking the server down. Shown under the top bar (App.vue) and at the top of every open Modal; App.vue signs the tab out at zero -->
  <div v-if="plannedSignOut && authenticated.loggedIn" role="alert"
    class="signout-bar w-full flex-shrink-0 min-h-7 px-4 py-1.5 text-center font-semibold whitespace-normal tabular-nums no-print border-b backdrop-blur-md
      bg-amber-400/90 text-neutral-950 border-amber-600/40 dark:bg-amber-500/75 dark:text-neutral-950 dark:border-amber-400/40">
    <span v-if="signOutStarter">Signing everyone else out in {{ signOutCountdown }}.</span>
    <span v-else class="hidden sm:inline">Maintenance: you’ll be signed out in {{ signOutCountdown }}. Save your work.</span>
    <span v-if="!signOutStarter" class="sm:hidden">Signing out in {{ signOutCountdown }}. Save your work.</span>
  </div>
</template>

<script>
import { computed, inject, onBeforeUnmount, ref, watch } from 'vue'

export default {
  name: 'SignOutBar',
  setup() {
    const global = inject('global')
    const { plannedSignOut, authenticated } = global

  // Refs
    const now = ref(Date.now())
    let tick = null

  // Computed
    const signOutCountdown = computed(() => {
      const left = Math.max(0, Math.ceil(((plannedSignOut.value?.endsAt ?? 0) - now.value) / 1000))
      return `${Math.floor(left / 60)}:${String(left % 60).padStart(2, '0')}`
    })
    const signOutStarter = computed(() => !!plannedSignOut.value?.byUserId && plannedSignOut.value.byUserId === String(authenticated.value?._id))

  // Watchers
    watch(plannedSignOut, (plan) => {
      clearInterval(tick)
      tick = null
      if (plan) {
        now.value = Date.now()
        tick = setInterval(() => { now.value = Date.now() }, 1000)
      }
    }, { immediate: true })

  // Lifecycle
    onBeforeUnmount(() => clearInterval(tick))

    return {
      plannedSignOut,
      authenticated,
      signOutCountdown,
      signOutStarter
    }
  }
}
</script>
